var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"merchant-header"},[_c('div',{staticClass:"merchant-banner",style:({'background-image': 'url('+_vm.merchant.backgroundImages+')'})}),_c('app-order-config')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }